import { Position } from "geojson";

import { GaiaMapMarker } from "~/modules/map/components/GaiaMapMarker";
import { IconFieldworker } from "~/modules/plannerV2/components/IconFieldworker";
import { IconFieldworkerVariant } from "~/modules/plannerV2/components/IconFieldworker/iconFieldworkerVariants";

type GaiaMapMarkerFieldworkerDraggableProps = {
    coordinates: Position;
    variant?: IconFieldworkerVariant;
};

export function GaiaMapMarkerFieldworkerDraggable({
    coordinates,
    variant = "pickup",
}: GaiaMapMarkerFieldworkerDraggableProps) {
    return (
        <GaiaMapMarker coordinates={coordinates} offset={[-20, -20]}>
            <IconFieldworker
                variant={variant}
                sx={{
                    border: "3px dashed grey",
                    transition: "all .3s ease-in-out ",
                    transform: "scale(1.2)",
                    "@starting-style": {
                        transform: "scale(1)",
                    },
                }}
            />
        </GaiaMapMarker>
    );
}
